const assignTallestHeight = (elementGroup: HTMLElement[]) => {
    // get all element heights from the provided list of elements
    const allElemetHeights: number[] = [...elementGroup].map(el => el.offsetHeight);

    // find the tallest height from that list
    const tallestElement = [Math.max(...allElemetHeights)].join();

    // assign the tallest height to all other elements in the provided list
    elementGroup.forEach(el => (el.style.minHeight = `${tallestElement}px`));
};

interface ElementsToResizeByTagName {
    [key: string]: HTMLElement[];
}

export default function resetTitlesHeightToTallest() {
    const vw = Math.max(
        document.documentElement.clientWidth || 0,
        window.innerWidth || 0
    );
    const allBlocksToResize = document.querySelectorAll('[data-block-reset-height]');

    // only for tablet and desktop - on mobile the cards are stacked.
    if (allBlocksToResize.length > 0 && vw > 480) {
        allBlocksToResize.forEach(blockToResize => {
            // get the titles for each module
            const allElementsToResize = blockToResize.querySelectorAll<HTMLElement>(
                '[data-element-reset-height]'
            );

            const groupedElementsToResize = Object.values(
                [...allElementsToResize].reduce(
                    (
                        elementsGroupedByTagName: ElementsToResizeByTagName,
                        elementToResize
                    ) => {
                        const { tagName } = elementToResize;
                        if (elementsGroupedByTagName[tagName]) {
                            elementsGroupedByTagName[tagName].push(elementToResize);
                        } else {
                            elementsGroupedByTagName[tagName] = [elementToResize];
                        }
                        return elementsGroupedByTagName;
                    },
                    {}
                )
            );

            groupedElementsToResize.forEach(elementGroup => {
                assignTallestHeight(elementGroup);
            });
        });
    }
}
